import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@fontsource-variable/inter/opsz.css'
import '../style.css'
import 'vue-sonner/style.css'
import ConsoleApp from '@/ConsoleApp.vue'
import router from '@/router/console'
import i18n from '@/locales'
import { useThemeStore } from '@/stores/theme'
import { installScrollbarWidth } from '@/lib/scrollbar'
import { installErrorTracking } from '@/lib/errorTracking'

// Publishes --scrollbar-w; the planning grids subtract it from their width
// floors (a container query cannot see the scrollport's own bar).
installScrollbarWidth()

const app = createApp(ConsoleApp)
installErrorTracking(app, 'console')
app.use(createPinia())
// Applies the theme before the first route renders — signed-out pages carry no
// toggle, so nothing else would instantiate the store there.
useThemeStore()
app.use(router)
app.use(i18n)
app.mount('#app')
